export const layoutConstants = {
    TOGGLE_MENU_MOBILE: 'TOGGLE_MENU_MOBILE'
};